import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { sitesApi } from '../lib/api';

export function useSites() {
  return useQuery({
    queryKey: ['sites'],
    queryFn: async () => {
      const response = await sitesApi.list();
      return response.data;
    },
  });
}

export function useSite(siteId: string) {
  return useQuery({
    queryKey: ['site', siteId],
    queryFn: async () => {
      const response = await sitesApi.get(siteId);
      return response.data;
    },
    enabled: !!siteId,
  });
}

export function useSiteStats(siteId: string) {
  return useQuery({
    queryKey: ['siteStats', siteId],
    queryFn: async () => {
      const response = await sitesApi.getStats(siteId);
      return response.data;
    },
    enabled: !!siteId,
  });
}

export function useSyncSites() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await sitesApi.sync();
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sites'] });
    },
  });
}

export function useDeleteSite() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (siteId: string) => {
      await sitesApi.delete(siteId);
      return siteId;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sites'] });
    },
  });
}

export function useDisconnectGoogle() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (siteId: string) => {
      await sitesApi.disconnectGoogle(siteId);
      return siteId;
    },
    onSuccess: (siteId) => {
      queryClient.invalidateQueries({ queryKey: ['site', siteId] });
      queryClient.invalidateQueries({ queryKey: ['sites'] });
    },
  });
}
